// NotFound.js

import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>
        Oops! Something went wrong! Help us improve your experience by sending
        an error report at TIMS_Support@dot.nyc.gov
      </h1>
    </div>
  );
};

export default NotFound;
